<template>
  <div id="app">
    <router-view v-if="verify" />
    <Spin fix v-else>
      <Icon type="ios-loading" size=28 class="rotate" />
      <div>加载中...</div>
    </Spin>
  </div>
</template>
<script>
export default {
  computed: {
    verify () {
      return this.$store.state.verify
    }
  },
  created () {
    this.$store.dispatch('init')
  },
  methods: {
    setBreakpoint () {
      const winWidth = window.innerWidth
      if (winWidth <= 600) {
        this.$store.commit('updateAppBreakpoint', true)
      } else if (winWidth > 600 && winWidth < 992) {
        this.$store.commit('updateCollapsed', true)
        this.$store.commit('updateAppBreakpoint', false)
      } else {
        this.$store.commit('updateCollapsed', false)
        this.$store.commit('updateAppBreakpoint', false)
      }
    }
  },
  mounted () {
    this.setBreakpoint()
    window.addEventListener('resize', () => {
      this.setBreakpoint()
    })
  }
}
</script>
